/**
 * O que o cliente vê enquanto a Dozy só recruta.
 * Não pede email nem telefone: uma lista de espera é outra decisão.
 *
 * Quem já tem sessão de cliente não pode reutilizar esta conta como
 * profissional. O registo não redirecciona uma sessão aberta, por isso
 * o botão antigo caía num formulário que recusava o mesmo email.
 */
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Icon from './Icon.js';
import { useAuth } from '../context/AuthContext';

const AZUL = '#0a6fd1';

const botao = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  minHeight: '44px',
  padding: '12px 18px',
  borderRadius: '14px',
  textDecoration: 'none',
  fontWeight: 800,
  fontSize: '0.98rem',
  boxSizing: 'border-box',
};

const PainelRecrutamento = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const terminarSessao = async () => {
    await logout();
    navigate('/register');
  };

  return (
    <section
      aria-labelledby="recrutamento-titulo"
      style={{ maxWidth: '680px', margin: '0 auto', padding: '8px 0 40px' }}
    >
      <p style={{
        margin: '0 0 10px',
        color: 'var(--accent-text, #0a6fd1)',
        fontSize: '0.78rem',
        fontWeight: 800,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
      }}
      >
        A abrir aos clientes em breve
      </p>
      <h1
        id="recrutamento-titulo"
        style={{
          fontFamily: "'Space Grotesk', sans-serif",
          fontSize: 'clamp(1.8rem, 4vw, 2.4rem)',
          fontWeight: 800,
          letterSpacing: '-0.03em',
          lineHeight: 1.1,
          margin: '0 0 12px',
          color: 'var(--text-primary, #0c203d)',
        }}
      >
        A Dozy está a recrutar profissionais e empresas.
      </h1>
      <p style={{
        margin: '0 0 22px',
        color: 'var(--text-secondary, #5e6b7d)',
        fontSize: '1.02rem',
        lineHeight: 1.6,
        maxWidth: '52ch',
      }}
      >
        Pedir um serviço, procurar alguém perto, abrir uma obra ou aderir ao
        Premium ainda não está disponível. A conta e o perfil continuam aqui.
        Quando abrirmos aos clientes, é aqui que vai pedir serviços.
      </p>
      {user && (
        <p style={{
          margin: '0 0 14px',
          color: 'var(--text-secondary, #5e6b7d)',
          fontSize: '0.95rem',
          lineHeight: 1.5,
          maxWidth: '52ch',
        }}
        >
          Esta conta é de cliente. O registo de profissional é outra conta.
        </p>
      )}
      <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
        {user ? (
          <button
            type="button"
            onClick={terminarSessao}
            style={{
              ...botao,
              background: AZUL,
              color: '#fff',
              border: 'none',
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            <Icon name="logout" size={18} color="#fff" /> Terminar sessão
          </button>
        ) : (
          <Link to="/register" style={{ ...botao, background: AZUL, color: '#fff' }}>
            <Icon name="briefcase" size={18} color="#fff" /> Sou profissional
          </Link>
        )}
        <Link to="/empresas" style={{
          ...botao,
          background: 'transparent',
          color: 'var(--text-primary, #0c203d)',
          border: '1px solid var(--input-border, #e7ebf0)',
        }}
        >
          <Icon name="bag" size={18} /> Dozy Empresas
        </Link>
      </div>
    </section>
  );
};

export default PainelRecrutamento;
